import Spline from "./Spline.svelte";
import { mergeAttributes, Node, nodeInputRule, nodePasteRule } from "@tiptap/core";
import { Alignment, Size } from "$components/editor/extensions/blocks/shared/attributes";
import { SvelteNodeViewRenderer } from "svelte-tiptap";
import { type MarkdownSerializerState } from "prosemirror-markdown";
import { type Node as PMNode } from "@tiptap/pm/model";

export interface EmbedOptions {
  inline: boolean;
  width: number | string;
  height: number | string;
}

export const SplineEmbed = Node.create<EmbedOptions>({
  name: "spline-embed",

  addOptions() {
    return {
      inline: false,
      width: Size.MEDIUM,
      height: "100%",
      match: [],
    };
  },

  inline() {
    return this.options.inline;
  },

  group() {
    return this.options.inline ? "inline" : "block";
  },

  draggable: true,

  addAttributes() {
    return {
      src: {
        default: null,
      },
      width: {
        default: this.options.width,
      },
      height: {
        default: this.options.height,
      },
      align: {
        default: Alignment.LEFT,
      },
      match: {
        default: [],
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "div[data-spline-embed]",
      },
    ];
  },

  addNodeView() {
    return SvelteNodeViewRenderer(Spline);
  },
  renderHTML({ HTMLAttributes }) {
    return ["spline-embed", mergeAttributes(HTMLAttributes)];
  },

  addInputRules() {
    return [
      nodeInputRule({
        // https://prod.spline.design/eZ5vjpM1IHtBtEPC/scene.splinecode
        find: /^(https?:\/\/)?(prod\.|my\.)?(spline\.design)(.+)?/,
        type: this.type,
        getAttributes: (match) => {
          return { src: match[0] };
        },
      }),
    ];
  },

  addPasteRules() {
    return [
      nodePasteRule({
        find: /^(https?:\/\/)?(prod\.|my\.)?(spline\.design)(.+)?/g,
        type: this.type,
        getAttributes: (match) => {
          return { match, src: match[0] };
        },
      }),
    ];
  },

  addStorage() {
    return {
      markdown: {
        serialize: (state: MarkdownSerializerState, node: PMNode) => {
          const src = node.attrs.src;
          state.write(`[Spline](${src})\n\n`);
        },
      },
    };
  },
});
